export function collectWarnings({ variant, quantity, photosQuantity }) {
  const keys = [];
  if (!quantityRespectsMinimum(variant, quantity)) keys.push("below_minimum");
  if (!quantityRespectsMultiplier(variant, quantity)) keys.push("not_multiple");
  if (!photosPerUnitRespected(variant, photosQuantity)) keys.push("photos_per_unit_mismatch");
  return keys;
}

function quantityRespectsMinimum(variant, quantity) {
  const min = variant?.minimum_quantity_restriction ?? 1;
  if (min <= 0) return true;
  return typeof quantity === "number" && quantity >= min;
}

function quantityRespectsMultiplier(variant, quantity) {
  const m = variant?.quantity_multiplier_restriction;
  if (!m || m <= 1) return true;
  return typeof quantity === "number" && quantity % m === 0;
}

function photosPerUnitRespected(variant, photosQuantity) {
  const ppu = variant?.photos_per_unit || 1;
  if (ppu <= 1) return true;
  return typeof photosQuantity === "number" && photosQuantity % ppu === 0;
}
